import { render, staticRenderFns } from "./CircularMail.vue?vue&type=template&id=5474abcf"
import script from "./CircularMail.vue?vue&type=script&lang=js"
export * from "./CircularMail.vue?vue&type=script&lang=js"
import style0 from "./CircularMail.vue?vue&type=style&index=0&id=5474abcf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports